import { createContext, useContext, useState } from "react";


const AppContext = createContext<any | null>(null);

export const AppContextProvider = ({children}: any) => {
    const [menuActive, setMenuActive] = useState(false);

    const toggleMenu = () => setMenuActive((prev) => !prev);
    const closeMenu = () => setMenuActive(false);

    return (
        <AppContext.Provider value={
            {
                menuActive,
                toggleMenu,
                closeMenu
            }
        }>
            {children}
        </AppContext.Provider>
    );

}    

export const useApp = () => {
    return useContext(AppContext)
}